<div class="row demo margin-left-if-scaled" style="background: var(--second-background)">
  <div class="col-xl-1"></div>
  <div class="col-sm-12 col-xl-5 demo-data margin-right-if-scaled">
    <h1 class="demo-title">Sibrica Software</h1>

    <div class="demo-data" style="padding-top: 0;">

      <h3 class="demo-description">
        <div style="display: flex; flex-direction: row; align-items: center">
          <mat-icon style="color: var(--accent-color); font-weight: 900; width: calc(var(--description-font-size) - 2px); height: calc(var(--description-font-size) - 2px); font-size: calc(var(--description-font-size) - 2px);">arrow_right</mat-icon>
        </div>
        <div>{{ 'sibrica paragraph 1' | language:'home':languageService.selectedLanguage }}</div>
      </h3>

      <h3 class="demo-description">
        <div style="display: flex; flex-direction: row; align-items: center">
          <mat-icon style="color: var(--accent-color); font-weight: 900; width: calc(var(--description-font-size) - 2px); height: calc(var(--description-font-size) - 2px); font-size: calc(var(--description-font-size) - 2px);">arrow_right</mat-icon>
        </div>
        <div>{{ 'sibrica paragraph 2' | language:'home':languageService.selectedLanguage }}</div>
      </h3>

      <h3 class="demo-description">
        <div style="display: flex; flex-direction: row; align-items: center">
          <mat-icon style="color: var(--accent-color); font-weight: 900; width: calc(var(--description-font-size) - 2px); height: calc(var(--description-font-size) - 2px); font-size: calc(var(--description-font-size) - 2px);">arrow_right</mat-icon>
        </div>
        <div>{{ 'sibrica paragraph 3' | language:'home':languageService.selectedLanguage }}</div>
      </h3>

      <h3 class="demo-description">
        <div style="display: flex; flex-direction: row; align-items: center">
          <mat-icon style="color: var(--accent-color); font-weight: 900; width: calc(var(--description-font-size) - 2px); height: calc(var(--description-font-size) - 2px); font-size: calc(var(--description-font-size) - 2px);">arrow_right</mat-icon>
        </div>
        <div>{{ 'sibrica paragraph 4' | language:'home':languageService.selectedLanguage }}</div>
      </h3>

      <h3 class="demo-description">
        <div style="display: flex; flex-direction: row; align-items: center">
          <mat-icon style="color: var(--accent-color); font-weight: 900; width: calc(var(--description-font-size) - 2px); height: calc(var(--description-font-size) - 2px); font-size: calc(var(--description-font-size) - 2px);">arrow_right</mat-icon>
        </div>
        <div>{{ 'sibrica paragraph 5' | language:'home':languageService.selectedLanguage }}</div>
      </h3>
    </div>

    <div class="demo-buttons">
      <a routerLink="/kontakt" class="not-underline"><button mat-button class="demo-button"><b>{{ 'sibrica first button' | language:'home':languageService.selectedLanguage }}</b></button></a>
      <a routerLink="/o-nas" class="not-underline"><button mat-button class="demo-button-2"><b style="padding: 0 12px">{{ 'sibrica second button' | language:'home':languageService.selectedLanguage }}</b></button></a>
    </div>

  </div>

  <div class="col-xl-1"></div>
  <div class="col-sm-12 col-xl-5 demo-movie noselect">
    <img class="image-scaler" width="650" height="500"
         style="max-width: 90vw; max-height: calc(90vw / 500 * 333.33); border-radius: 16px;" [alt]="'sibrica image alt' | language:'home':languageService.selectedLanguage"
         src="./assets/vector/sibrica-it-projects-development.png">
    <!--    <img class="image-scaler" width="500" style="max-width: 90vw; border-radius: 16px;" src="https://image.shutterstock.com/image-photo/colleagues-working-on-agile-product-260nw-1376317913.jpg">-->
    <!--    <iframe style="max-width: 90vw; max-height: calc(90vw * 315 / 560)" src="https://www.youtube.com/embed/QH2-TGUlwu4" width="560" height="315" frameborder="0"></iframe>-->
  </div>
</div>



  <!-- -->
 <section class="trust-bar">
    <p class="trust-text">{{ languageService.getLang('experience_title', 'experience') }}</p>
    <div class="logo-grid">
      <div class="logo-item" style="scale: 0.9"><img src="assets/logos/logo_hurra.svg" alt="Hurra Communications"></div>
      <div class="logo-item" style="scale: 1.2"><img src="assets/logos/logo_onet.svg" alt="Onet"></div>
      <div class="logo-item" style="scale: 1.0"><img src="assets/logos/logo_First_Utility.svg" alt="First Utility"></div>
    </div>
</section>

<div class="header border-top-radius">
  <div class="try-now-container">
    <h2 class="try-now-description">{{ 'first header' | language:'home':languageService.selectedLanguage }}</h2>
  </div>
</div>

<!-- -->

<div style="background-color: var(--background);">
  <div class="row" style="justify-content: center">
    <div class="col-xs-12 col-sm-10 col-md-4">
      <div class="pocket-card">
        <div class="do-nothing top-card-height">
          <div style="margin-left: 22px; margin-top: 22px">
            <mat-icon class="icons noselect"
              style="background-color: rgba(1, 168, 165, 0.15); color: #01a8a5;">
              miscellaneous_services
            </mat-icon>
          </div>
          <h3 class="custom-card-header"><b style="font-weight: 500">{{ 'first card title' | language:'home':languageService.selectedLanguage }}</b></h3>
          <h4 class="custom-second-header" style="margin-bottom: calc(var(--title-font-size));">{{ 'first card subtitle' | language:'home':languageService.selectedLanguage }}</h4>


        </div>
        <!--<img src="./assets/home-image-1.jpg" [alt]="'first card image alt' | language:'home':languageService.selectedLanguage" class="image noselect">-->
        <img src="./assets/vector/sibrica-big-data-analytics-solutions.jpg" [alt]="'first card image alt' | language:'home':languageService.selectedLanguage" class="image noselect">

        <div
          style="margin-top: calc(var(--title-font-size)); display: flex; flex-direction: column; justify-content: space-between;" class="bottom-card-height">
          <h4 class="custom-second-header"><b>{{ 'first card description title' | language:'home':languageService.selectedLanguage }}</b></h4>
          <h4 class="custom-second-header">{{ 'first card description' | language:'home':languageService.selectedLanguage }}</h4>

          <div style="display: flex; justify-content: center; margin: 5%">
            <a style="display: flex; flex: 1" routerLink="/big-data" class="not-underline"><button mat-button class="demo-button-2"><b>{{ 'first card button' | language:'home':languageService.selectedLanguage }}</b></button></a>
          </div>
        </div>


      </div>
    </div>

        <!-- -->

    <div class="col-xs-12 col-sm-10 col-md-4">
      <div class="pocket-card">
        <div class="do-nothing top-card-height">
          <div style="margin-left: 22px; margin-top: 22px">
<!--            <mat-icon class="icons"-->
<!--              style="background-color: rgba(33, 150, 243, 0.15); color: #01a8a5;">-->
            <mat-icon class="icons noselect"
              style="background-color: rgba(139, 72, 222, 0.15); color: #8b48de;">
              equalizer
            </mat-icon>
          </div>
          <h3 class="custom-card-header"><b style="font-weight: 500">{{ 'second card title' | language:'home':languageService.selectedLanguage }}</b></h3>
          <h4 class="custom-second-header" style="margin-bottom: calc(var(--title-font-size));">{{ 'second card subtitle' | language:'home':languageService.selectedLanguage }}</h4>


        </div>
        <img src="./assets/vector/sibrica-data-warehouse-project.jpg" [alt]="'second card image alt' | language:'home':languageService.selectedLanguage" class="image noselect">

        <div
          style="display: flex; flex-direction: column; justify-content: space-between;" class="bottom-card-height">
          <h4 class="custom-second-header"><b>{{ 'second card description title' | language:'home':languageService.selectedLanguage }}</b></h4>
          <h4 class="custom-second-header">{{ 'second card description' | language:'home':languageService.selectedLanguage }}</h4>

          <div style="display: flex; justify-content: center; margin: 5%">
            <a style="display: flex; flex: 1" routerLink="/hurtownie-danych" class="not-underline"><button mat-button class="demo-button-2"><b>{{ 'second card button' | language:'home':languageService.selectedLanguage }}</b></button></a>
          </div>
        </div>


      </div>
    </div>

        <!-- -->

    <div class="col-xs-12 col-sm-10 col-md-4">
      <div class="pocket-card">
        <div class="do-nothing top-card-height">
          <div style="margin-left: 22px; margin-top: 22px">
            <mat-icon class="icons noselect"
              style="background-color: rgba(243, 97, 93, 0.15); color: #f3615d;">
              rocket
            </mat-icon>
          </div>
          <h3 class="custom-card-header"><b style="font-weight: 500">{{ 'third card title' | language:'home':languageService.selectedLanguage }}</b></h3>
          <h4 class="custom-second-header" style="margin-bottom: calc(var(--title-font-size));">{{ 'third card subtitle' | language:'home':languageService.selectedLanguage }}</h4>


        </div>
        <img src="./assets/vector/sibirca-it-database-optimalisation.jpg" [alt]="'third card image alt' | language:'home':languageService.selectedLanguage" class="image noselect">

        <div style="display: flex; flex-direction: column; justify-content: space-between;" class="bottom-card-height">
          <h4 class="custom-second-header"><b>{{ 'third card description title' | language:'home':languageService.selectedLanguage }}</b>
          </h4>
          <h4 class="custom-second-header">{{ 'third card description' | language:'home':languageService.selectedLanguage }}</h4>

          <div style="display: flex; justify-content: center; margin: 5%">
            <a style="display: flex; flex: 1" routerLink="/optymalizacja-systemow" class="not-underline"><button mat-button class="demo-button-2"><b>{{ 'third card button' | language:'home':languageService.selectedLanguage }}</b></button></a>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

        <!-- -->

<div class="header">
  <div class="try-now-container">
    <h2 class="try-now-description">{{ 'second header' | language:'home':languageService.selectedLanguage }}</h2>
  </div>
</div>


<div style="background-color: var(--background)">
  <div class="row" style="justify-content: center">
    <div class="col-xs-12 col-sm-10 col-md-5">
      <div class="pocket-card">
        <div class="top-card-height">
          <div style="margin-left: 22px; margin-top: 22px">
            <mat-icon class="icons noselect"
              style="background-color: rgba(83, 178, 255, 0.15); color: #53b2ff;">
              verified_user
            </mat-icon>
          </div>
          <h3 class="custom-card-header"><b style="font-weight: 500">{{ 'fourth card title' | language:'home':languageService.selectedLanguage }}</b></h3>
          <h4 class="custom-second-header" style="margin-bottom: calc(var(--title-font-size));">{{ 'fourth card subtitle' | language:'home':languageService.selectedLanguage }}</h4>


        </div>
        <!--<img src="./assets/home-image-4.jpg" [alt]="'fourth card image alt' | language:'home':languageService.selectedLanguage" class="image noselect">-->
        <img src="./assets/vector/sibrica-it-project-security.jpg" [alt]="'fourth card image alt' | language:'home':languageService.selectedLanguage" class="image noselect">

        <div
          style="display: flex; flex-direction: column; justify-content: space-between;" class="bottom-card-height">
          <h4 class="custom-second-header"><b>{{ 'fourth card description title' | language:'home':languageService.selectedLanguage }}</b></h4>
          <h4 class="custom-second-header">{{ 'fourth card description' | language:'home':languageService.selectedLanguage }}</h4>

          <div style="display: flex; justify-content: center; margin: 5%">
            <a style="display: flex; flex: 1" routerLink="/bezpieczenstwo" class="not-underline"><button mat-button class="demo-button-2"><b>{{ 'fourth card button' | language:'home':languageService.selectedLanguage }}</b></button></a>
          </div>
        </div>


      </div>
    </div>

    <div class="col-xs-12 col-sm-10 col-md-5">
      <div class="pocket-card">
        <div class="top-card-height">
          <div style="margin-left: 22px; margin-top: 22px">
            <mat-icon class="icons noselect"
              style="background-color: rgba(34, 139, 34, 0.15); color: #228B22;">
              public
            </mat-icon>
          </div>
          <h3 class="custom-card-header"><b style="font-weight: 500">{{ 'fifth card title' | language:'home':languageService.selectedLanguage }}</b></h3>
          <h4 class="custom-second-header" style="margin-bottom: calc(var(--title-font-size));">{{ 'fifth card subtitle' | language:'home':languageService.selectedLanguage }}</h4>


        </div>
        <!--<img src="./assets/home-image-5.jpg" [alt]="'fifth card image alt' | language:'home':languageService.selectedLanguage" class="image noselect">-->
        <img src="./assets/vector/sibrica-it-project-reliable.jpg" [alt]="'fifth card image alt' | language:'home':languageService.selectedLanguage" class="image noselect">

        <div style="display: flex; flex-direction: column; justify-content: space-between;" class="bottom-card-height">
          <h4 class="custom-second-header"><b>{{ 'fifth card description title' | language:'home':languageService.selectedLanguage }}</b>
          </h4>
          <h4 class="custom-second-header">{{ 'fifth card description' | language:'home':languageService.selectedLanguage }}</h4>

          <div style="display: flex; justify-content: center; margin: 5%;">
            <a style="display: flex; flex: 1" routerLink="/rozwiazania-duzej-dostepnosci" class="not-underline"><button mat-button class="demo-button-2"><b>{{ 'fifth card button' | language:'home':languageService.selectedLanguage }}</b></button></a>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>

<div class="header border-bottom-radius">
  <div class="try-now-container">
    <h2 class="try-now-description">{{ 'third header first line' | language:'home':languageService.selectedLanguage }}<br>{{ 'third header second line' | language:'home':languageService.selectedLanguage }}</h2>
  </div>
</div>

<div style="text-align: center; padding: 30px; font-size: var(--second-title-font-size); font-weight: 500;">
  {{ 'follow us on' | language:'home':languageService.selectedLanguage }}
</div>

<div style="display: flex; flex-direction: row; justify-content: center; align-items: center; gap: calc(75 / 36 * var(--second-title-font-size))">
<!-- icons from https://iconscout.com/i -->

  <!-- youtube -->
  <!--
  <a href="">
  <svg xmlns="http://www.w3.org/2000/svg" style="height: calc(50 / 36 * var(--second-title-font-size)); cursor: pointer" viewBox="5.368 13.434 53.9 37.855">
    <path fill="#ffffff" d="M41.272 31.81c-4.942-2.641-9.674-5.069-14.511-7.604v15.165c5.09-2.767 10.455-5.301 14.532-7.561h-.021z" class="colorFFF svgShape"/>
    <path fill="#e8e0e0" d="M41.272 31.81c-4.942-2.641-14.511-7.604-14.511-7.604l12.758 8.575c.001 0-2.324 1.289 1.753-.971z" class="colorE8E0E0 svgShape"/>
    <path fill="#3378cc" d="M27.691 51.242c-10.265-.189-13.771-.359-15.926-.803-1.458-.295-2.725-.95-3.654-1.9-.718-.719-1.289-1.816-1.732-3.338-.38-1.268-.528-2.323-.739-4.9-.323-5.816-.4-10.571 0-15.884.33-2.934.49-6.417 2.682-8.449 1.035-.951 2.239-1.563 3.591-1.816 2.112-.401 11.11-.718 20.425-.718 9.294 0 18.312.317 20.426.718 1.689.317 3.273 1.267 4.203 2.492 2 3.146 2.035 7.058 2.238 10.118.084 1.458.084 9.737 0 11.195-.316 4.836-.57 6.547-1.288 8.321-.444 1.12-.823 1.711-1.479 2.366a7.085 7.085 0 0 1-3.76 1.922c-8.883.668-16.426.813-24.987.676zM41.294 31.81c-4.942-2.641-9.674-5.09-14.511-7.625v15.166c5.09-2.767 10.456-5.302 14.532-7.562l-.021.021z" class="colorCD201F svgShape"/>
  </svg>
  </a>
  -->

  <!-- linkedin -->
  <a href="https://www.linkedin.com/company/sibrica/">
    <svg xmlns="http://www.w3.org/2000/svg" style="height: calc(50 / 36 * var(--second-title-font-size)); cursor: pointer" fill="#fff" aria-label="LinkedIn" viewBox="0 0 512 512">
      <rect width="512" height="512" fill="#3378cc" rx="15%" class="color0077b5 svgShape"/>
      <circle cx="142" cy="138" r="37" fill="#ffffff" class="color000 svgShape"/>
      <path stroke="#fff" stroke-width="66" d="M244 194v198M142 194v198" fill="#ffffff" class="color000 svgShape colorStrokefff svgStroke"/>
      <path d="M276 282c0-20 13-40 36-40 24 0 33 18 33 45v105h66V279c0-61-32-89-76-89-34 0-51 19-59 32" fill="#ffffff" class="color000 svgShape"/>
    </svg>
  </a>

  <!-- facebook -->
  <!--
  <a href="">
    <svg xmlns="http://www.w3.org/2000/svg" style="height: calc(50 / 36 * var(--second-title-font-size)); cursor: pointer" data-name="Ebene 1" viewBox="0 0 1024 1024">
      <path fill="#3378cc" d="M1024,512C1024,229.23016,794.76978,0,512,0S0,229.23016,0,512c0,255.554,187.231,467.37012,432,505.77777V660H302V512H432V399.2C432,270.87982,508.43854,200,625.38922,200,681.40765,200,740,210,740,210V336H675.43713C611.83508,336,592,375.46667,592,415.95728V512H734L711.3,660H592v357.77777C836.769,979.37012,1024,767.554,1024,512Z" class="color1877f2 svgShape"/>
      <path fill="#ffffff" d="M711.3,660,734,512H592V415.95728C592,375.46667,611.83508,336,675.43713,336H740V210s-58.59235-10-114.61078-10C508.43854,200,432,270.87982,432,399.2V512H302V660H432v357.77777a517.39619,517.39619,0,0,0,160,0V660Z" class="colorfff svgShape"/>
    </svg>
  </a>
  -->

</div>
